import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CtaBanner() {
  return <section data-section-id="256829" id="צרו-קשר" className="py-20 bg-gradient-to-b from-primary to-primary/90 text-primary-foreground">
      <div className="container mx-auto px-4 flex flex-col items-center text-center">
        <div className="max-w-3xl">
          <h2 className="text-3xl md:text-5xl font-bold font-default mb-6 tracking-tight">
            זקוקים למטפל סיעודי באופן מיידי?
          </h2>
          <p className="text-lg md:text-xl mb-10 opacity-90 font-default max-w-2xl mx-auto leading-relaxed">
            אנחנו כאן בשבילכם עם פתרון מקצועי ומהיר תוך 5 שעות בלבד. הצטרפו למאות משפחות שכבר נהנות משקט נפשי וטיפול מסור.
          </p>
          <Button asChild size="lg" variant="secondary" className="rounded-lg shadow-md hover:shadow-lg transition-all duration-300 text-base px-8 h-12">
            <Link to="/ContactPage">
              צרו קשר עכשיו
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}